var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiveInvoice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Receive_Invoice"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Receive_Invoice",
    "data-name": "Receive Invoice",
    clipPath: "url(#clip-Receive_Invoice)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invoice_1_",
    "data-name": "invoice (1)",
    transform: "translate(-78.86 -79.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19954",
    "data-name": "Path 19954",
    d: "M94.565,88.794h.23q1.061,0,2.121,0a.826.826,0,0,1,.916.925q0,3.172,0,6.345a2.449,2.449,0,0,1-2.512,2.515q-6.46,0-12.919,0a2.448,2.448,0,0,1-2.514-2.513q0-6.46,0-12.919A2.446,2.446,0,0,1,82.4,80.634q4.826,0,9.651,0a2.438,2.438,0,0,1,2.513,2.508c0,1.8,0,3.593,0,5.389Zm-1.625,8.152v-.21q0-6.764,0-13.528A.837.837,0,0,0,92,82.267H82.464a.835.835,0,0,0-.944.954q0,6.382,0,12.764a.839.839,0,0,0,.956.961H92.941Zm1.639-6.518v6.518h.7a.828.828,0,0,0,.918-.922q0-2.694,0-5.388v-.208Z",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19955",
    "data-name": "Path 19955",
    d: "M147.9,178.091c-1.083,0-2.165,0-3.248,0a.815.815,0,0,1-.8-.618.8.8,0,0,1,.421-.915,1.019,1.019,0,0,1,.422-.1q3.21-.009,6.42,0a.818.818,0,1,1-.006,1.632Q149.5,178.093,147.9,178.091Z",
    transform: "translate(-60.675 -90.931)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19956",
    "data-name": "Path 19956",
    d: "M148,242.09c-1.076,0-2.152,0-3.228,0a.811.811,0,0,1-.116-1.616c.057-.005.114-.006.172-.006q3.19,0,6.38,0a.816.816,0,0,1,.842.557.8.8,0,0,1-.744,1.062c-.675.013-1.35,0-2.025,0Z",
    transform: "translate(-60.787 -151.672)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19957",
    "data-name": "Path 19957",
    d: "M146.383,304.272c.522,0,1.044,0,1.565,0a.818.818,0,1,1,.009,1.632q-1.584.006-3.169,0a.817.817,0,1,1,.01-1.632C145.327,304.271,145.855,304.272,146.383,304.272Z",
    transform: "translate(-60.78 -212.219)",
    fill: "#0072ce"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveInvoice);
export default __webpack_public_path__ + "static/media/Receive Invoice.f60210daa1e17b11e52bc5956eaf71bf.svg";
export { ForwardRef as ReactComponent };